//POP up message on scrolling banner section

// function deleteCookie(name) {
//   document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
// }

// function setCookie(cname, cvalue, exdays) {
//   const d = new Date();
//   d.setTime(d.getTime() + (exdays*24*60*60*1000));
//   let expires = "expires="+ d.toUTCString();
//   document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
// }

// function getCookie(cname) {
//   let name = cname + "=";
//   let decodedCookie = decodeURIComponent(document.cookie);
//   let ca = decodedCookie.split(';');
//   for(let i = 0; i <ca.length; i++) {
//     let c = ca[i];
//     while (c.charAt(0) == ' ') {
//       c = c.substring(1);
//     }
//     if (c.indexOf(name) == 0) {
//       return c.substring(name.length, c.length);
//     }
//   }
//   return "";
// }

// var FootertypingTimer;
// var FooterinputField = $('#footer_mailinglist_email');
// function onUserStoppedTypingFooter() {
//   var popup_value = getCookie('popup_value');
//   if(popup_value === 1) {
//     return true;
//   }
//   else {
//     deleteCookie('popup_value');
//     setCookie('popup_value',1,1);
//   }
// }
// FooterinputField.on('keyup', function() {
//   clearTimeout(FootertypingTimer);
//   FootertypingTimer = setTimeout(onUserStoppedTypingFooter, 1000);
// });


// var SignUPtypingTimer;
// var SignUPinputField = $('#custom_sign_up');
// function onUserStoppedTypingSignUP() {
//   var popup_value = getCookie('popup_value');
//   if(popup_value === 2) {
//     return true;
//   }
//   else {
//     deleteCookie('popup_value');
//     setCookie('popup_value',2,1);
//   }
// }
//  SignUPinputField.on('keyup', function() {
//    clearTimeout(SignUPtypingTimer);
//    SignUPtypingTimer = setTimeout(onUserStoppedTypingSignUP, 1000);
//  });


//  $(document).ready(function() {
//   var footer_popup_text = 'Thank you for signing up!';
//   var banner_popup_text = 'Thank you for signing up and taking a chance to enter our £250 voucher draw prize! We will be in touch as soon as possible with more information. In the meantime, welcome to our hive!';
//    console.log(footer_popup_text);
//  const params = new Proxy(new URLSearchParams(window.location.search), {
//  get: (searchParams, prop) => searchParams.get(prop),
//  });
//  let customer_posted = params.customer_posted;
//  if(customer_posted == "true")
//  {
//    var popup_value = getCookie('popup_value');
//   var resselector = $(`.cc-popup-form .cc-popup-form__response.cc-popup-form__response--success h5`);
//    if(popup_value == 1)
//    {
//     resselector.text(footer_popup_text);
//    }
//    else if(popup_value == 2)
//   {
//     resselector.text(banner_popup_text);
//   }
// }
//  });

$(document).ready(function() {
  $("#shopify-section-template--20766673207587__scrolling-banner a").click(function() {
    var formOffset = $("#footer--newsletter").offset().top;

    $("html, body").animate({
      scrollTop: formOffset
    }, 1000);
  });
});
